
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/business/entertainment",
      function () {
        return require("private-next-pages/business/entertainment/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/business/entertainment"])
      });
    }
  